import { useState } from "react";
// import Geral from "../Relatorio/Types/geral";
import Patrimonios from "../Relatorio/Types/patrimonios";
import Anexos from "../Relatorio/Types/anexos";
import TabNavigation from "../../General/TabNavigation";
import Secretarias from "../Relatorio/Types/secretarias";
import FaturamentoTotal from "../Relatorio/Types/faturamentoTotal";

const Relatorio = () => {
  const [activeTab, setActiveTab] = useState("Patrimonios");

  const tabs = [
    {
      key: "FaturamentoTotal",
      label: "Faturamento Total",
      icon: "chart",
      content: <FaturamentoTotal />
    },
    // {
    //   key: "Geral",
    //   label: "Geral",
    //   icon: "chart",
    //   content: <Geral />
    // },
    {
      key: "Patrimonios",
      label: "Patrimonios",
      icon: "chart",
      content: <Patrimonios />
    },
    {
      key: "Anexos",
      label: "Anexos",
      icon: "folder",
      content: <Anexos />
    },
    {
      key: "Secretarias",
      label: "Secretarias",
      icon: "config",
      content: <Secretarias />
    }
  ];

  return (
    <TabNavigation
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      variant="default"
    />
  );
};

export default Relatorio;
